<template>
  <div class="preview-box">

    <component
      :is="previewType"
      :mpe="mpe"
      :channel="channel" />

  </div>
</template>

<script>
const TwitterProfile = () => import('@/components/standard/display/channelPreview/channels/TwitterProfile')
const FacebookPage = () => import('@/components/standard/display/channelPreview/channels/FacebookPage')
const SqwizPage = () => import('@/components/standard/display/channelPreview/channels/SqwizPage')
const InformacijaShop = () => import('@/components/standard/display/channelPreview/channels/InformacijaShop')
const WordpressUser = () => import('@/components/standard/display/channelPreview/channels/WordpressUser')
import props from '@/mixins/standard/preview/props'

export default {
  computed: {
    /**
     * Tells what preview component to use
     * @returns {String|undefined}
     */
    previewType () {
      let { type = '' } = this.channel
      if (!type) return undefined
      return `${type[0].toUpperCase()}${type.slice(1)}`
    }

  },

  components: {
    TwitterProfile,
    FacebookPage,
    SqwizPage,
    InformacijaShop,
    WordpressUser
  },

  mixins: [ props ]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/standard/display/channelPreview/Preview.vue?55587d28